<template>
  <div class="navigation-btns-container" v-if="IsMainPage && !$isMobile()">
    <div class="next-page-button nav-page-button-container" :class="{hidden : IsLastPage}">
      <span
        class="next-image nav-image blink_me"
        src="../assets/misc/next.png"
        alt="next -image"
        @click="GoNext"
      >
        <i class="fas fa-chevron-right"></i>
      </span>
    </div>

    <div class="previous-page-button nav-page-button-container" :class="{hidden : IsFirstPage}">
      <span
        class="previous-image nav-image blink_me"
        src="../assets/misc/previous.png"
        alt="previous -image"
        @click="GoBack"
      >
        <i class="fas fa-chevron-left"></i>
      </span>
    </div>
  </div>
</template>

<script>
import common from "../mixins/CommonFunctions";
export default {
  mixins: [common],
  data: function () {
    return {};
  },
  methods: {},

  computed: {
    IsLastPage: function () {
      let index = this.GetCurrentRouteIndex();
      return index >= this.MainRoutes.length;
    },
    IsFirstPage: function () {
      let currentPath = this.GetCurrentRoute().path;
      return currentPath === "/home";
    },
    IsMainPage: function () {
      let currentPath = this.GetCurrentRoute();

      if (!currentPath) return false;

      return currentPath.IsMainPath;
    },
  },
};
</script>










<style>
.nav-image {
  position: fixed;
  height: 66px;
  padding: 20px;
  border: 0px solid white;
  top: 0;
  bottom: 0;
  margin: auto;
  cursor: pointer;
  z-index: 999999;
  -webkit-transition: color 0.5s;
  -o-transition: color 0.5s;
  transition: color 0.5s;
  font-size: 20px;
}

.nav-image:hover {
  color: brown;
}

.next-page-button .next-image {
  right: 43px;
}
.nav-image i {
  cursor: pointer;
  color: #ececec;
}

.previous-page-button .previous-image {
  left: 43px;
}

.hidden {
  display: none;
}
@media (min-width: 481px) and (max-width: 767px),
  (min-width: 320px) and (max-width: 480px),
  (min-width: 768px) and (max-width: 1024px) {
  .nav-page-button-container {
    display: none !important;
  }
}
</style>